export const JAMB_SUBJECTS = [
  "COMMERCE",
  "ACCOUNTING",
  "MARKETING",
  "CHRISTIAN RELIGIOUS STUDIES",
  "ECONOMICS",
  "GEOGRAPHY",
  "GOVERNMENT",
  "NIGERIAN HISTORY",
  "ISLAMIC STUDIES",
  "LITERATURE IN ENGLISH",
  "CIVIC EDUCATION",
  "ARABIC",
  "ENGLISH LANGUAGE",
  "FRENCH",
  "HAUSA",
  "IGBO",
  "YORUBA",
  "FURTHER MATHEMATICS",
  "GENERAL MATHEMATICS",
  "AGRICULTURE",
  "BIOLOGY",
  "CHEMISTRY",
  "HEALTH EDUCATION",
  "PHYSICAL EDUCATION",
  "PHYSICS",
  "TECHNICAL DRAWING",
  "FOODS AND NUTRITION",
  "HOME MANAGEMENT",
  "MUSIC",
  "VISUAL ART",
];
